module.exports = __webpack_public_path__ + "static/img/Taiwan.58cfbb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/landmark/Taiwan.png
// module id = Fg30
// module chunks = 1